import React from "react";
import { BaseFormFieldProps } from "models/propTypes/wintFormPropsTypes";
import { CurrencyHelper, LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import FilterInput from "./filterInput";

const CurrencySelectionInput: React.FC<BaseFormFieldProps> = (props) => {
  const suggestedCurrencies = React.useMemo(
    () =>
      CurrencyHelper.getSuggestedCurrencyList().map((key, index) => ({
        id: key,
        value: key,
        description: LocalizationHelperInstance.getFormattedMessage(key),
        group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
      })),
    []
  );

  const currencies = React.useMemo(
    () =>
      CurrencyHelper.getCurrencyCodeList().map((key, index) => ({
        id: key,
        value: key,
        description: LocalizationHelperInstance.getFormattedMessage(key),
        group: "",
      })),
    []
  );

  return (
    <FilterInput
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Currency)}
      {...props}
      items={currencies}
      suggestedItems={suggestedCurrencies}
      data-testid={`${props.name}CurrencySelectionInput`}
    />
  );
};

export default CurrencySelectionInput;
